import { HttpBasicRequest } from "app/shared/models/http-basic-request.model";
import { PaymentTermsByChannelDTO, PaymentTermsByChannelVM } from "../models/back-office-admin-common/channel-payment-term.model";

export class PaymentTermOverrideMapper {
  public static PaymentTermByChannelDto(paymentTermOverride: PaymentTermsByChannelVM): PaymentTermsByChannelDTO {

    let channel = paymentTermOverride.channel;
    delete channel.checked;
    delete channel.disabled;

    let paymentTerm = paymentTermOverride.paymentTerm;
    delete paymentTerm.checked;

    return new PaymentTermsByChannelDTO({
      channel,
      paymentTerm,
      paymentTermId: paymentTermOverride.paymentTermId,
      id: paymentTermOverride.id,
      channelId: paymentTermOverride.channel.id,
    });

  }

  public static PaymentTermOverrideRequest(paymentOverride: PaymentTermsByChannelDTO[], cachePaymentOverride: PaymentTermsByChannelDTO[], baseUrl: string, customerId: number): HttpBasicRequest[] {
    const result: HttpBasicRequest[] = [];

    const paymentOverrideToCreate = paymentOverride.filter(x => !x.id);
    const paymentOverrideToDelete = cachePaymentOverride.filter(x => !paymentOverride.find(y => y.id === x.id));
    const paymentOverrideToUpdate = paymentOverride.filter(x => x.id && !paymentOverrideToDelete.find(y => y.id === x.id));

    paymentOverrideToCreate.forEach(payment => {
      result.push({
        url: `${baseUrl}/customers/${customerId}/payment-term-overrides/`, method: 'post', body: {
          channelId: payment.channel.id,
          paymentTermId: payment.paymentTerm.id,
        },
      });
    });

    paymentOverrideToDelete.forEach(payment => {
      result.push({ url: `${baseUrl}/customers/${customerId}/payment-term-overrides/${payment.id}`, method: 'delete', });
    });

    paymentOverrideToUpdate?.filter((element1) => !cachePaymentOverride.some(element2 => element1.paymentTerm.id === element2.paymentTerm.id)).forEach(payment => {
      result.push({ url: `${baseUrl}/customers/${customerId}/payment-term-overrides/${payment.id}`, method: 'put', body: { paymentTermId: payment.paymentTerm.id } });
    });
    return result;
  }
}
